import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/png/process_banner.png'


const _withScopeId = n => (_pushScopeId("data-v-97ea76aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-lg container-fluid list_partners" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "header d-none" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "text-primary" }, " Need: Improve Treatment Support For TB Patients "),
  /*#__PURE__*/_createElementVNode("h5", { class: "text-primary" }, " Video Treatment Support (VOT) for TB Patients Via Mobiles ")
], -1))
const _hoisted_3 = { class: "card card-body border-0 shadow mb-3" }
const _hoisted_4 = { class: "p-text-center" }
const _hoisted_5 = { class: "p-text-center" }
const _hoisted_6 = ["href"]
const _hoisted_7 = ["href"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-5" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "How to accept a partnership"),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "process_banner",
    class: "img-fluid w-100"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SubBar = _resolveComponent("SubBar")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_ViewMouDeclaration = _resolveComponent("ViewMouDeclaration")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_SubBar),
    _createElementVNode("section", _hoisted_3, [
      _createVNode(_component_DataTable, {
        responsiveLayout: "scroll",
        breakpoint: "700px",
        value: _ctx.datas,
        paginator: true,
        loading: _ctx.loading,
        rows: 10,
        selectionMode: "single",
        columnResizeMode: "fit",
        scrollHeight: "flex",
        globalFilterFields: ['innovation'],
        filters: _ctx.filters,
        "onUpdate:filters": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters) = $event)),
        filterDisplay: "menu",
        class: "p-datatable-sm",
        onRowClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toMouForm($event))),
        "row-hover": true
      }, {
        empty: _withCtx(() => [
          _createElementVNode("h6", _hoisted_4, "No " + _toDisplayString(_ctx.title) + " found.", 1)
        ]),
        loading: _withCtx(() => [
          _createElementVNode("h6", _hoisted_5, "Loading " + _toDisplayString(_ctx.title) + " data. Please wait.", 1)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_Column, {
            header: "Partners",
            sortable: true,
            style: {"min-width":"10rem"},
            frozen: true
          }, {
            body: _withCtx((slotProps) => [
              _createElementVNode("span", {
                class: _normalizeClass({ slotProps })
              }, _toDisplayString(slotProps.data?.partner?.firstname) + " " + _toDisplayString(slotProps.data?.partner?.lastname) + ", ", 3)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "",
            header: "Negotiation status",
            style: {"min-width":"10rem"}
          }, {
            body: _withCtx((slotProps) => [
              _createElementVNode("span", {
                class: _normalizeClass({ slotProps })
              }, _toDisplayString(slotProps.data?.status), 3)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            style: {"min-width":"10rem"},
            field: "partnership_interest",
            header: "Contact details"
          }, {
            body: _withCtx((slotProps) => [
              _createElementVNode("a", {
                href: `mailto:${slotProps.data?.partner.email}`
              }, _toDisplayString(slotProps.data?.partner.email), 9, _hoisted_6),
              _createTextVNode(",  "),
              _createElementVNode("a", {
                href: `tel:${slotProps.data?.partner.mobile}`
              }, _toDisplayString(slotProps.data?.partner.mobile), 9, _hoisted_7)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value", "loading", "filters"])
    ]),
    _hoisted_8,
    _createVNode(_component_Dialog, {
      header: _ctx.partnershipModalHeader,
      visible: _ctx.partnershipsModal,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.partnershipsModal) = $event)),
      style: { width: '30rem' },
      modal: true
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ViewMouDeclaration)
      ]),
      _: 1
    }, 8, ["header", "visible"])
  ]))
}